import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const ImagePickerPreview_Box_1 = styled.div`
  position: relative;
  overflow: hidden;

  &[data-format-equals-banner-and-not-preview-height] {
    height: 80px;

    @media all and (min-width: ${cssBreakpoints.mdUp}) {
      height: 200px;
    }
  }
`;

export const ImagePickerPreview_Box_2 = styled.div`
  height: auto;

  &[data-is-banner-with-overlay] {
    height: 80px;

    @media all and (min-width: ${cssBreakpoints.mdUp}) {
      height: 200px;
    }
  }
`;
